import type { ReactNode } from "react";

interface CalloutProps {
  type?: "info" | "warning" | "tip" | "danger";
  title?: string;
  children: ReactNode;
}

const icons: Record<string, string> = {
  info: "circle-info",
  warning: "triangle-exclamation",
  tip: "lightbulb",
  danger: "circle-xmark",
};

const colors: Record<string, { bg: string; border: string; icon: string }> = {
  info: {
    bg: "bg-info-subtle",
    border: "border-info",
    icon: "text-info",
  },
  warning: {
    bg: "bg-warning-subtle",
    border: "border-warning",
    icon: "text-warning",
  },
  tip: {
    bg: "bg-success-subtle",
    border: "border-success",
    icon: "text-success",
  },
  danger: {
    bg: "bg-danger-subtle",
    border: "border-danger",
    icon: "text-danger",
  },
};

export default function Callout({ type = "info", title, children }: CalloutProps) {
  const color = colors[type];
  const icon = icons[type];

  return (
    <div
      className={`${color.bg} border-l-4 ${color.border} rounded-lg p-4 mb-4`}
    >
      <div className="flex items-start gap-2">
        <i
          className={`fa-solid fa-${icon} ${color.icon} mt-0.5`}
        />
        <div className="flex-1 flex flex-col gap-1">
          {title && (
            <div className={`font-semibold ${color.icon}`}>
              {title}
            </div>
          )}
          <div className="text-sm">{children}</div>
        </div>
      </div>
    </div>
  );
}
